/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { triggerSync } from '../fn/oeamtc-sync/trigger-sync';
import { TriggerSync$Params } from '../fn/oeamtc-sync/trigger-sync';

@Injectable({ providedIn: 'root' })
export class OeamtcSyncService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `triggerSync()` */
  static readonly TriggerSyncPath = '/api/v1/{tenant_short_code}/sync';

  /**
   * Trigger a sync.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `triggerSync()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerSync$Response(params: TriggerSync$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return triggerSync(this.http, this.rootUrl, params, context);
  }

  /**
   * Trigger a sync.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `triggerSync$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerSync(params: TriggerSync$Params, context?: HttpContext): Observable<void> {
    return this.triggerSync$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
